export const PayChange = {
    card: 'online',
    cash: 'cash',
};
